export default __webpack_public_path__ + "static/media/710.91237c5a.png";